import { Search } from '@/components/Elements/Filter';
import { SectionHeading } from '@/components/Layout/SectionHeading';

import { EmployeesTakeTable } from '../components/EmployeesTakeTable';
import { Filters } from '../components/Filters';
import { SelectPaycycleCurrency } from '../components/SelectPaycycleCurrency';

export const EmployeesTake = () => {
  return (
    <>
      <SectionHeading
        title="What your workers take home 🏡"
        actionComponents={[<SelectPaycycleCurrency key="SelectPaycycleCurrency" />]}
      />
      <Search placeholder="Search by worker name" />
      <Filters />
      <EmployeesTakeTable />
    </>
  );
};
